import { useTranslation } from 'react-i18next';

import { useLogtoAuth } from '@/hooks/useLogtoAuth';

/**
 * Full-screen lockout shown by <AdminGate> when the active build has
 * `VITE_ADMIN_GATE_ENABLED=true` and the authenticated QLASH user does not
 * carry `is_admin === true`. The CTA reuses `useLogtoAuth().signOut` so the
 * user can drop their session and re-authenticate with an admin account.
 *
 * Visual shape mirrors <Login /> for consistency — same dark background,
 * brand-coloured header, single primary button.
 */
export function AccessDenied() {
  const { t } = useTranslation('general');
  const { signOut } = useLogtoAuth();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-bg p-6 text-text">
      <div className="flex flex-col items-center gap-3">
        <h1 className="text-3xl font-bold tracking-tight text-brand">QLASH</h1>
        <h2 className="text-xl font-semibold text-fg">{t('accessDenied.title')}</h2>
        <p className="max-w-sm text-center text-sm text-fg-muted">
          {t('accessDenied.message')}
        </p>
      </div>

      <button
        type="button"
        onClick={() => signOut()}
        className="rounded-md bg-brand px-8 py-3 text-base font-medium text-brand-fg transition-opacity active:opacity-80"
      >
        {t('accessDenied.signOut')}
      </button>
    </div>
  );
}
